module.exports = __webpack_public_path__ + "static/media/cq_cassetto_digitale.9185077d.svg";